<template>
  <div class="header">
    <div class="nav-top">
      <div class="nav-left">
        <h2>托乐乐管理后台</h2>
        <span>{{ userInfo.company_name }}</span>
      </div>
      <div class="nav-right fn-right fn-clear">
        <!-- <div class="my-message fn-left">
          <div class="message_num">12</div>
          <img :src="MyMessage" class="center-self-y" alt />
          <span>我的消息</span>
        </div>-->
        <router-link
          v-if="$route.meta.activeMenu != 'instruction'"
          class="help-centre fn-left"
          to="/admin/instruction"
        >
          <img :src="HelpCentre" class="center-self-y" alt>
          <span>操作指南</span>
        </router-link>
        <router-link v-else class="home-icon fn-left" to="/admin/home">
          <img :src="HomeIcon" class="center-self-y" alt>
          <span>返回后台首页</span>
        </router-link>
        <div class="surname fn-left" @click="flag = !flag">
          <div class="surname_btn">
            <span>{{ userInfo.nickname.substr(0, 1) }}</span>
          </div>
          <div class="surname_box" />
          <ul v-show="flag" class="list">
            <p>
              <span>{{ userInfo.nickname }}</span>
              <span>{{ userInfo.obligation_name }}</span>
            </p>
            <li class="update" @click="updatePasswordFormVisible = true">
              <i />
              <span>修改密码</span>
            </li>
            <li class="logout" @click="logout()">
              <i />
              <span>退出</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="$route.meta.activeMenu != 'instruction'" class="breadcrumb">
      <el-breadcrumb separator="/" replace="true">
        <el-breadcrumb-item v-for="(item, index) in breadList" :key="index">{{
          item
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-dialog title="修改密码" :visible.sync="updatePasswordFormVisible">
      <i style="color: brown;"> * 字母和数字，下划线_及破折号-；6~18个字符</i>
      <el-form
        ref="updatePasswordForm"
        :model="passwordForm"
        :rules="passwordRules"
      >
        <!-- <el-form-item label="原登录密码" prop="old_pwd">
          <el-input
            v-model="passwordForm.old_pwd"
            type="password"
            autocomplete="off"
          />
        </el-form-item> -->
        
        <el-form-item label="新登录密码" prop="new_pwd">
          <el-input
            v-model="passwordForm.new_pwd"
            type="password"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_pwd">
          <el-input
            v-model="passwordForm.confirm_pwd"
            type="password"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="confirmUpdatePassword"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      HelpCentre: require('@/assets/img/help-centre.png'),
      MyMessage: require('@/assets/img/my-message.png'),
      HomeIcon: require('@/assets/img/home-icon.png'),
      flag: false,
      userInfo: {
        nickname: ''
      },
      breadList: [],
      updatePasswordFormVisible: false,
      passwordForm: {
        old_pwd: '',
        new_pwd: '',
        confirm_pwd: ''
      },
      passwordRules: {
        old_pwd: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入旧密码'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        new_pwd: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入新密码'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        confirm_pwd: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.passwordForm.new_pwd) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    $route() {
      this.breadList = []
      for (const routeInfo of this.$route.matched) {
        if (typeof routeInfo.name === 'string' && routeInfo.name !== 'admin') {
          this.breadList.push(routeInfo.name)
        }
      }
    }
  },
  mounted() {
    this.userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    this.breadList = []
    for (const routeInfo of this.$route.matched) {
      if (typeof routeInfo.name === 'string' && routeInfo.name !== 'admin') {
        this.breadList.push(routeInfo.name)
      }
    }
  },
  methods: {
    async logout() {
      const ret = await this.$http.loginout()
      if (ret.code == 200) {
        // 在不影响clear原代码的情况下重置isread是否显示更新
        var updateId = localStorage.getItem('isRead')
        localStorage.clear()
        localStorage.setItem('isRead', updateId)
        this.$router.push({ path: '/login' })
      }
    },
    confirmUpdatePassword() {
      this.$refs.updatePasswordForm.validate(async valid => {
        if (valid) {
          const ret = await this.$http.updatePassword(this.passwordForm)
          if (ret.code == 200) {
            this.updatePasswordFormVisible = false
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  background-color: #fff;
  .nav-top {
    width: 100%;
    height: 70px;
    line-height: 70px;
    padding: 0 20px;
    border-bottom: 2px solid #eeeeee;
    .nav-left {
      display: inline-block;
      h2 {
        position: relative;
        display: inline-block;
        font-size: 20px;
        color: $color_blue;
        -webkit-font-smoothing: antialiased;
      }
      h2:after {
        position: absolute;
        top: 50%;
        left: 180px;
        margin-top: -10px;
        width: 2px;
        height: 20px;
        content: "";
        display: inline-block;
        background-color: #999999;
      }
      span {
        margin-left: 66px;
      }
    }
    .nav-right {
      margin-right: 52px;
      .surname {
        cursor: pointer;
        position: relative;
        .surname_btn {
          position: absolute;
          top: 50%;
          right: 0;
          margin-top: 15px;
          width: 40px;
          height: 40px;
          background-color: #f0f3fa;
          border-radius: 50%;
          line-height: 40px;
          text-align: center;
          font-size: 19px;
          color: $color_blue;
        }
        .surname_box {
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          position: absolute;
          top: 50px;
          width: 0;
          height: 0;
          border-width: 6px;
          border-style: solid;
          border-color: transparent transparent transparent $color_blue;
        }
        .list {
          position: absolute;
          right: 0;
          top: 70px;
          width: 200px;
          padding-bottom: 10px;
          background-color: #fff;
          z-index: 99;
          box-shadow: 0px 0px 10px 0px rgba(168, 168, 168, 0.5);
          p {
            height: 40px;
            line-height: 40px;
            background-color: $color_blue;
            color: #fff;
            padding-left: 10px;
          }
          li {
            width: 100%;
            height: 30px;
            line-height: 30px;
            padding-left: 10px;
            &.update {
              i {
                width: 12px;
                height: 12px;
                background: url("../../assets/img/update_password.png");
                background-size: 100%;
                display: inline-block;
              }
            }
            &.logout {
              i {
                width: 12px;
                height: 12px;
                background: url("../../assets/img/exit.png");
                background-size: 100%;
                display: inline-block;
              }
            }
            span {
              padding-left: 11px;
            }
          }
          li {
            &.update {
              &:hover {
                color: $color_blue;
                i {
                  background: url("../../assets/img/update_password_b.png");
                  background-size: 100%;
                }
              }
            }
          }
          li {
            &.logout {
              &:hover {
                color: $color_blue;
                i {
                  background: url("../../assets/img/exit_b.png");
                  background-size: 100%;
                }
              }
            }
          }
        }
      }
      .help-centre,
      .my-message,
      .home-icon {
        margin-right: 80px;
        position: relative;
        cursor: pointer;
        color: $color_black;
        .message_num {
          position: absolute;
          top: 32px;
          right: 87px;
          width: 16px;
          height: 16px;
          background-color: $color_blue;
          border-radius: 2px;
          z-index: 9999;
          color: #ffffff;
          text-align: center;
          line-height: 16px;
          font-size: 12px;
        }
        img {
          position: absolute;
          left: -30px;
          width: 22px;
          height: 22px;
        }
      }
    }
  }
  ::v-deep .breadcrumb {
    width: 100%;
    height: 68px;
    padding: 0 40px;
    background-color: #5b74ab;
    .el-breadcrumb {
      line-height: 68px;
      .el-breadcrumb__inner {
        color: #fff !important;
      }
      .presentation {
        color: #fff !important;
      }
    }
  }
  ::v-deep .el-dialog {
    width: 620px;
    height: 553px;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .el-dialog__header {
      padding: 30px 35px 20px 20px;
      border-bottom: solid 1px #f5f5f5;
      .el-dialog__title {
        color: $color_blue;
        font-size: 22px;
      }
      .el-dialog__close {
        color: $color_blue;
        font-size: 20px;
      }
      .el-dialog__headerbtn {
        top: 31px;
        right: 35px;
      }
    }
    .el-dialog__body {
      padding: 30px 35px 100px 30px;
    }
    .el-dialog__footer {
      text-align: left;
      padding-left: 110px;
    }
    .el-form-item {
      margin-bottom: 20px;
      .el-input {
        width: 220px;
      }
    }
    .el-button {
      width: 134px;
      height: 40px;
    }
  }
}
</style>
